import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MediaInterface } from '@core/interfaces/media.interface';

@Component({
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'media',
  },
  standalone: false,
})
export class MediaComponent {
  @Input() media: MediaInterface;
  @Input() isVideoBlock = false;

  @ViewChild('video', {static: true}) videoRef: ElementRef;

  get source() {
    return this.media.urls.full;
  }

  get thumbnailUrl() {
    return this.hasAnyThumbnails() ? this.media.urls.thumbnails[0] : '';
  }

  getAttribute(name: string) {
    return this.media?.attributes?.includes(name);
  }

  private hasAnyThumbnails(): boolean {
    return Object.keys(this.media.urls.thumbnails).length > 0;
  }
}
